import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { AppCommonService } from '../../appcommon.service';
import { IBlog } from '../../blogs/blog';
import { BlogService } from '../../blogs/blog.service';
import { BlogType } from './../blogtypes';
import { ActivatedRoute } from '@angular/router';

declare var $: any;
@Component({
  selector: 'mft-myfleetsolutionsv2',
  templateUrl: './myfleetsolutionsv2.component.html',
  styleUrls: ['./myfleetsolutionsv2.component.css']
})
export class Myfleetsolutionsv2Component implements OnInit, AfterViewInit {

  public pageTitle: string = 'My Fleet Solutions';
  blogsList: IBlog[];
  category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService, private route: ActivatedRoute
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;

  }
  ngOnInit() {
    this.category = BlogType.myfleetsolutions;
    this.loadBlogsList();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();

    $('.tabs-left li a').click(function () {
      $(this).parent().siblings().removeClass("active");
    });

    $('.tabs-left li a').hover(function () {
      $(this).trigger('click');
    });


    /*$('.sliderformobile').bxSlider({
      auto: true,
      pager: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true
    });*/

    $('#MyServiceExpert').on('show.bs.modal', function (e) {
      $("#MyServiceExpert_video").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#MyServiceExpert').on('hide.bs.modal', function (e) {
      $("#MyServiceExpert_video").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg");
    });

    $('#TeleGence').on('show.bs.modal', function (e) {
      $("#TeleGence_video").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#TeleGence').on('hide.bs.modal', function (e) {
      $("#TeleGence_video").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o");
    });

    $('#MyDriveSafe').on('show.bs.modal', function (e) {
      $("#MyDriveSafe_video").attr('src', "https://www.youtube.com/embed/IkV8u2G2StY?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#MyDriveSafe').on('hide.bs.modal', function (e) {
      $("#MyDriveSafe_video").attr('src', "https://www.youtube.com/embed/IkV8u2G2StY");
    });

    $('#MileageCount').on('show.bs.modal', function (e) {
      $("#MileageCount_video").attr('src', "https://www.youtube.com/embed/Q6Vi0i7OBR0?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#MileageCount').on('hide.bs.modal', function (e) {
      $("#MileageCount_video").attr('src', "https://www.youtube.com/embed/Q6Vi0i7OBR0");
    });

    $('#CardProtect').on('show.bs.modal', function (e) {
      $("#CardProtect_video").attr('src', "https://www.youtube.com/embed/8HCeEJHD4v0?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#CardProtect').on('hide.bs.modal', function (e) {
      $("#CardProtect_video").attr('src', "https://www.youtube.com/embed/8HCeEJHD4v0");
    });

    $('#CO2Count').on('show.bs.modal', function (e) {
      $("#CO2Count_video").attr('src', "https://www.youtube.com/embed/QWSl_ZJOTgo?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#CO2Count').on('hide.bs.modal', function (e) {
      $("#CO2Count_video").attr('src', "https://www.youtube.com/embed/QWSl_ZJOTgo");
    });

    $('#FleetToolbox').on('show.bs.modal', function (e) {
      $("#FleetToolbox_video").attr('src', "https://www.youtube.com/embed/vGEjxVba7MQ?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#FleetToolbox').on('hide.bs.modal', function (e) {
      $("#FleetToolbox_video").attr('src', "https://www.youtube.com/embed/vGEjxVba7MQ");
    });


    $(".verticalslider").slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1580,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 881,
          settings: {
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 581,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    });

    this.route.fragment.subscribe((fragment: string) => {
      var Id = this.GetId(fragment);

      $("#p" + fragment).trigger('click');


      $('.verticalslider').slick('slickGoTo', Id);
    })
  }

  loadBlogsList() {
    this.blogService.getBlogsList(this.category)
      .subscribe(
        (blogs: IBlog[]) => {
          this.blogsList = blogs;
        },
        (error: any) => {
          this.blogService.showError("Blog retrieval problem", <any>error)
        }
      );
  }


  GetId(fragment: string) {

    let val = 0;
    switch (fragment) {
      case "p21":
        val = 0;
        break;
      case "p22":
        val = 1;
        break;
      case "p23":
        val = 2;
        break;
      case "p24":
        val = 3;
        break;
      case "p25":
        val = 4;
        break;
      case "p26":
        val = 5;
        break;
      case "p27":
        val = 6;
        break;
      case "p28":
        val = 7;
        break;
      case "p29":
        val = 8;
        break;

      default:
        val = 0;
        break;

    }
    return val;

  }

  InitializeSlick() {

    return $(".verticalslider").slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1580,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 881,
          settings: {
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 581,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/myfleetsolutionsv2/myfleetsolutionsv2.component.ts